import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const IntermediateAdvancedTrainingProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Intermediate & Advanced Training Program</h2>
                            <p>
                                The Intermediate & Advanced Training Program at Net Nest Badminton Sports Club is designed for players who have already mastered the basics of badminton and are ready to take their game to the next level. This program focuses on refining techniques, enhancing physical fitness, and developing the tactical and mental skills required for competitive performance.
                            </p>
                            <p>
                                <h2>Program Overview</h2>
                                This training program bridges the gap between foundational learning and competitive excellence. It is ideal for players who understand the rules of the game, can sustain rallies, and are looking to improve consistency, speed, and match control. Training sessions are structured, intensive, and performance-oriented, ensuring steady improvement and measurable progress.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Intermediate Training Program.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Technical Skill Development</h2>
                            <p>
                                Advanced footwork patterns and court movement
                                <br></br>
                                Stroke refinement for clears, drops, smashes, and drives
                                <br></br>
                                Net play, deception shots, and defensive techniques
                                <br></br>
                                Shot placement and rally control
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Tactical & Match Strategy Training</h2>
                            <p>
                                Singles and doubles strategies
                                <br></br>
                                Reading opponents’ strengths and weaknesses
                                <br></br>
                                Shot selection and rally planning
                                <br></br>
                                Positioning and court coverage
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Physical Fitness & Conditioning</h2>
                            <p>
                                Speed, agility, and explosive movement
                                <br></br>
                                Endurance and stamina building
                                <br></br>
                                Core strength and flexibility
                                <br></br>
                                Injury prevention and recovery techniques
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Conditioning & Match Temperament</h2>
                            <p>
                                Handle match pressure and maintain focus
                                <br></br>
                                Build confidence and resilience
                                <br></br>
                                Develop discipline and consistency
                                <br></br>
                                Improve concentration and decision-making
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Match Practice & Competitive Exposure</h2>
                            <p>
                                Practice matches and internal competitions
                                <br></br>
                                Performance analysis and feedback sessions
                                <br></br>
                                Tournament preparation routines
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Personalized Performance Monitoring</h2>
                            <p>
                                Each player’s progress is closely monitored by coaches. Individual assessments help identify areas for improvement, and training plans are adjusted accordingly. Personalized feedback ensures continuous growth and long-term development.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Should Join This Program?</h2>
                            <p>
                                Players with basic to strong badminton fundamentals
                                <br></br>
                                Intermediate players aiming to improve consistency and strategy
                                <br></br>
                                Advanced players preparing for competitive tournaments
                                <br></br>
                                Athletes seeking performance-oriented training
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default IntermediateAdvancedTrainingProgram;
